import { createApiClient } from '@aimsos/api-client';
import { tokenService } from '@aimsos/auth';

function lazyClient(urlKey, envFallbacks) {
  let instance = null;
  return new Proxy(
    {},
    {
      get(_, prop) {
        if (!instance) {
          const shell = window.__AIMS_SHELL__ || {};
          const rawBase =
            shell[urlKey] ||
            envFallbacks.find(Boolean) ||
            '';
          instance = createApiClient({
            baseURL: rawBase.replace(/\/+$/, ''),
            getToken: () => tokenService.getToken(),
            refreshToken: async () => {
              const userUuid = localStorage.getItem('user_uuid') || undefined;
              const tenantUuid = localStorage.getItem('workspace_uuid') || undefined;
              return tokenService.refreshToken(userUuid, tenantUuid);
            },
          }).client;
        }
        const value = instance[prop];
        return typeof value === 'function' ? value.bind(instance) : value;
      },
    },
  );
}

/** Workspaces API — /v0/* routes (VITE_API_BASE_URL_WS) */
export const api = lazyClient('apiBaseUrlWS', [
  import.meta.env.VITE_API_BASE_URL_WS,
  import.meta.env.VITE_API_BASE_URL,
]);

/** Standard platform API — /v1/* routes (VITE_API_BASE_URL) */
export const apiStd = lazyClient('apiBaseUrl', [import.meta.env.VITE_API_BASE_URL]);

/** Auth API — auth-specific routes (VITE_API_BASE_URL_AUTH) */
export const apiAuth = lazyClient('apiBaseUrlAuth', [import.meta.env.VITE_API_BASE_URL_AUTH]);
